export default __webpack_public_path__ + "static/media/settings.db23ae94.svg";